import { styled } from '@common/utils/styles'
import { Paper } from '@common/components'

export const Steppper = styled(Paper)(() => ({
  height: '8px',
  width: '100%',
  transition: 'background 0.3s ease-in-out',
}))
